// frontend/src/components/PreLoginHeader.js

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { label: "Explore", path: "/explore" },
  { label: "Discover", path: "/circles-preview" },
  { label: "Circles", path: "/circle-details-preview" },
  { label: "About", path: "/about" },
];

function PreLoginHeader() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isLoginPage = pathname === "/" || pathname === "/login";

  const isAuthPage = isLoginPage || pathname === "/signup" || pathname === "/forgotpassword" || pathname === "/resetpassword";

  const isPreviewPage =
    NAV_ITEMS.some((item) => item.path === pathname) ||
    pathname === "/gothampotterydemo" ||
    pathname === "/bklynclaydemo";
    
  const isLandingHero = isAuthPage;

  return (
    <header className="absolute inset-x-0 top-0 z-30">
      <div className="mx-auto flex h-20 w-full max-w-7xl -translate-y-0.5 items-center justify-between px-3 sm:px-6 md:px-10 xl:pl-16 xl:pr-12">
        {/* LEFT: desktop logo or spacing */}
        <div className="hidden h-full min-w-0 items-center lg:flex">
          {!isLoginPage && isPreviewPage ? (
            <Link
              to="/login"
              aria-label="Go to login"
              className="
                logo-font
                flex h-full items-center
                -translate-y-[6px]
                whitespace-nowrap
                pl-2 sm:pl-4
                text-[1.7rem] sm:text-[1.8rem]
                focus:outline-none
                transition-opacity
                md:hover:text-blue-400
              "
            >
              third place
            </Link>
          ) : (
            <div
              aria-hidden="true"
              className="h-full w-0 lg:w-[170px]"
            />
          )}
        </div>

        {/* MOBILE: show navigation on all pages */}
        <nav
          aria-label="Mobile preview navigation"
          className="
            ml-5 flex min-w-0 items-center gap-3
            sm:gap-5
            lg:hidden
          "
        >
          {NAV_ITEMS.map((item) => {
            const active = pathname === item.path;

            return (
              <button
                key={item.path}
                type="button"
                onClick={() => navigate(item.path)}
                aria-current={active ? "page" : undefined}
                className={`
                  !min-h-0 !min-w-0
                  whitespace-nowrap
                  bg-transparent px-0 py-2
                  text-[14px] font-semibold
                  transition-colors duration-200
                  sm:text-[15px]
                  ${
                    isLandingHero
                      ? "text-gray-100 hover:text-blue-600"
                      : active
                      ? "text-blue-600"
                      : "text-gray-500 hover:text-blue-400"
                  }
                `}
              >
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* DESKTOP: preview navigation */}
        <nav
          aria-label="Preview navigation"
          className="
            absolute left-1/2 hidden -translate-x-1/2
            items-center gap-7 lg:flex
          "
        >
          {NAV_ITEMS.map((item) => {
            const active = pathname === item.path;

            return (
              <button
                key={item.path}
                type="button"
                onClick={() => navigate(item.path)}
                aria-current={active ? "page" : undefined}
                className={`
                  !min-h-0 !min-w-0
                  bg-transparent px-0 py-2
                  text-[18px] font-semibold
                  transition-colors duration-200
                  ${
                    isLandingHero
                      ? "text-gray-100 hover:text-blue-600"
                      : active
                      ? "text-blue-600"
                      : "text-gray-500 hover:text-blue-400"
                  }
                `}
              >
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* RIGHT: Join on Login; Log in + Join on preview pages */}
        <div className="ml-auto flex shrink-0 items-center gap-2.5">
          {!isLoginPage && (
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="
                hidden
                !min-h-0 !min-w-0
                rounded-full bg-white
                px-3 text-sm font-semibold text-[#6f665d]
                transition
                hover:ring-2 hover:ring-blue-400
                hover:animate-[wiggle_1s_ease-in-out_infinite]
                sm:px-4 sm:py-1.5
                lg:block
              "
            >
              Log in
            </button>
          )}

          <button
            type="button"
            onClick={() => navigate("/signup")}
            className="
              mr-5
              !min-h-0 !min-w-0
              rounded-full bg-blue-600
              px-3 py-1
              text-[13px] font-semibold text-white
              transition
              hover:ring-2 hover:ring-blue-400
              hover:animate-[wiggle_1s_ease-in-out_infinite]
              sm:mr-0 sm:px-4 sm:py-1.5 sm:text-sm
            "
          >
            Join
          </button>
        </div>
      </div>
    </header>
  );
}

export default PreLoginHeader;